import React, { useState } from "react";

import { useDispatch } from "react-redux";
import {
  invalidateGDocEditorReference,
  syncGDocEditorReference,
} from "src/redux/actions/gdocIntegration";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Image } from "react-bootstrap";

import { fetchAsset } from "src/redux/actions/assets";


import _ from "lodash";
import styles from "./gdocsSync.module.scss"

const LoadingIcon = '/images/loading_plane.gif';

const GDocEditorProcessing: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const assetId = params.assetId;

  const asset = useSelector((state: any) => _.get(state, "assets.item", null));
  const processed = useSelector((state: any) =>
    _.get(state, "gDocIntegration.processed", false),
  );

  let totalTimeSpent = 0;

  const [currentETag, setCurrentETag] = useState(null);

  const renderValidationMessage = () => {
    return (
      <div className={styles.loading}>
        <Image src={LoadingIcon} />
        <h4 className={styles.title}>Processing asset....</h4>
        <div className={styles.message}>This might take sometime, the page will refresh automatically</div>
      </div>
    );
  };

  React.useEffect(() => {
    if (assetId) {
      dispatch(syncGDocEditorReference({ assetId: assetId }));
      dispatch(fetchAsset({ assetId: assetId }));
  }

    const syncTimer = setInterval(() => {

      if (totalTimeSpent > 600) {
        navigate({ pathname: `/assets/${assetId}` });
      }
      totalTimeSpent = totalTimeSpent + 30;
    }, 30000);

    return () => {
      dispatch(invalidateGDocEditorReference());
      if (syncTimer) {
        clearInterval(syncTimer);
      }
    };
  }, []);

  React.useEffect(() => {
    if (processed) {
      navigate({ pathname: `/assets/${assetId}` });
    }

    if (asset) {
      var oldEtag = currentETag;
      var newEtag = asset.metadata.etag;

      if (oldEtag && newEtag && oldEtag != newEtag) {
        navigate({ pathname: `/assets/${assetId}` });
      }

      if (newEtag) {
        setCurrentETag(newEtag);
      }
    }
  }, [processed, asset]);

  return (
    <div className={styles.content}>
      <div className={styles.container}>
        <div className={styles.dialog}>{renderValidationMessage()}</div>
      </div>
    </div>
  );
};

export default GDocEditorProcessing;
